import { getFromStorage, saveToStorage } from "./used-vue/api/Storage";

let acceptFunctional = false;
if (getFromStorage('cookies_functional') == 1) {
    acceptFunctional = true;
}
let acceptAnalytical = false;
if (getFromStorage('cookies_analytical') == 1) {
    acceptAnalytical = true;
}
let acceptMarketing = false;
if (getFromStorage('cookies_marketing') == 1) {
    acceptMarketing = true;
}
let cookiesAccepted = false;
if (getFromStorage('cookies_accepted') == 1) {
    cookiesAccepted = true;
}

const initGoogleMaps = () => {
    console.log('Google Maps loaded');
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDoBjhfSsYd9pjdbAq6GeMgHcfk5KLD120&libraries=places&callback=googleMapsLoaded';
    document.head.appendChild(script);
};

const initLiveChat = () => {
    console.log('Live chat loaded');
    window.lpTag=window.lpTag||{},'undefined'==typeof window.lpTag._tagCount?(window.lpTag={wl:lpTag.wl||null,scp:lpTag.scp||null,site:'34811337'||'',section:lpTag.section||'',tagletSection:lpTag.tagletSection||null,autoStart:lpTag.autoStart!==!1,ovr:lpTag.ovr||{},_v:'1.10.0',_tagCount:1,protocol:'https:',events:{bind:function(t,e,i){lpTag.defer(function(){lpTag.events.bind(t,e,i)},0)},trigger:function(t,e,i){lpTag.defer(function(){lpTag.events.trigger(t,e,i)},1)}},defer:function(t,e){0===e?(this._defB=this._defB||[],this._defB.push(t)):1===e?(this._defT=this._defT||[],this._defT.push(t)):(this._defL=this._defL||[],this._defL.push(t))},load:function(t,e,i){var n=this;setTimeout(function(){n._load(t,e,i)},0)},_load:function(t,e,i){var n=t;t||(n=this.protocol+'//'+(this.ovr&&this.ovr.domain?this.ovr.domain:'lptag.liveperson.net')+'/tag/tag.js?site='+this.site);var o=document.createElement('script');o.setAttribute('charset',e?e:'UTF-8'),i&&o.setAttribute('id',i),o.setAttribute('src',n),document.getElementsByTagName('head').item(0).appendChild(o)},init:function(){this._timing=this._timing||{},this._timing.start=(new Date).getTime();var t=this;window.attachEvent?window.attachEvent('onload',function(){t._domReady('domReady')}):(window.addEventListener('DOMContentLoaded',function(){t._domReady('contReady')},!1),window.addEventListener('load',function(){t._domReady('domReady')},!1)),'undefined'===typeof window._lptStop&&this.load()},start:function(){this.autoStart=!0},_domReady:function(t){this.isDom||(this.isDom=!0,this.events.trigger('LPT','DOM_READY',{t:t})),this._timing[t]=(new Date).getTime()},vars:lpTag.vars||[],dbs:lpTag.dbs||[],ctn:lpTag.ctn||[],sdes:lpTag.sdes||[],hooks:lpTag.hooks||[],identities:lpTag.identities||[],ev:lpTag.ev||[]},lpTag.init()):window.lpTag._tagCount+=1;
};

const initHotjar = () => {
    console.log('Hotjar loaded');
    if (typeof window.loadHotjar == 'undefined') {
        return;
    }
    if (window.loadHotjar === false) {
        return;
    }
    (function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:2901373,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
};

const initFunctional = () => {
    if (!acceptFunctional) {
        console.log('Functional cookies not accepted');
        saveToStorage('cookies_functional', 0);
        return;
    }
    acceptFunctional = true;
    saveToStorage('cookies_functional', 1);
    initLiveChat();

};

const initAnalytical = () => {
    if (!acceptAnalytical) {
        console.log('Analytical cookies not accepted');
        saveToStorage('cookies_analytical', 0);
        return;
    }
    acceptAnalytical = true;
    saveToStorage('cookies_analytical', 1);
};

const initMarketing = () => {
    if (!acceptMarketing) {
        console.log('Marketing cookies not accepted');
        saveToStorage('cookies_marketing', 0);
        return;
    }
    acceptMarketing = true;
    saveToStorage('cookies_marketing', 1);
    initHotjar();
}

const updateGoogleTagManager = () => {
    gtag('consent', 'update', {
        ad_user_data: acceptMarketing ? 'granted' : 'denied',
        ad_personalization: acceptMarketing ? 'granted' : 'denied',
        ad_storage: acceptMarketing ? 'granted' : 'denied',
        analytics_storage: acceptAnalytical ? 'granted' : 'denied'
    });
};

const initCookieDescriptionAcordions = () => {
    const headings = cookieCard.querySelectorAll('.cookie-card__summary-heading');
    headings.forEach(heading => {
        heading.addEventListener('click', event => {
            const target = heading.getAttribute('aria-controls');
            if (!target) {
                console.error('Target not found for value: ' + heading.dataset.target);
                return;
            }
            // Get the element parent and then get the .cookie-card__summary-expand
            const expandIcon = heading.querySelector('.cookie-card__summary-expand');
            if (expandIcon) {
                expandIcon.classList.toggle('cookie-card__summary-expand--open');
            }
            const targetElement = cookieCard.querySelector('#' + target);
            if (!targetElement) {
                console.error('Target not found for value: ' + target);
                return;
            }
            targetElement.classList.toggle('cookie-card__summary-content--open');
        });
    });
};

const cookieCard = document.getElementById('cookieCardBg');
const initCookieCard = () => {
    if (!cookieCard) {
        console.error('Cookie card not found');
        return;
    }

    document.querySelector('html').classList.add('cookie-card-active');

    if (cookiesAccepted) {
        console.log('Cookies already accepted');
        initFunctional();
        initAnalytical();
        initMarketing();
        updateGoogleTagManager();
        document.querySelector('html').classList.remove('cookie-card-active');
        cookieCard.remove();
        return;
    }

    cookieCard.classList.add('cookie-card--open');

    initCookieDescriptionAcordions();

    cookieCard.querySelector('.cookie-card__button--accept').addEventListener('click', event => {
        console.log('Cookie card accept clicked');

        acceptFunctional = true;
        acceptAnalytical = true;
        acceptMarketing = true;

        initFunctional();
        initAnalytical();
        initMarketing();
        updateGoogleTagManager();

        saveToStorage('cookies_accepted', 1);
        document.querySelector('html').classList.remove('cookie-card-active');
        cookieCard.remove();
    });

    cookieCard.querySelector('.cookie-card__button--reject').addEventListener('click', event => {
        console.log('Cookie card reject clicked');

        acceptFunctional = false;
        acceptAnalytical = false;
        acceptMarketing = false;

        initFunctional();
        initAnalytical();
        initMarketing();
        updateGoogleTagManager();

        saveToStorage('cookies_accepted', 1);
        document.querySelector('html').classList.remove('cookie-card-active');
        cookieCard.remove();
    });

    cookieCard.querySelector('.cookie-card__button--save').addEventListener('click', event => {
        console.log('Cookie card save clicked');

        initFunctional();
        initAnalytical();
        initMarketing();
        updateGoogleTagManager();

        saveToStorage('cookies_accepted', 1);
        document.querySelector('html').classList.remove('cookie-card-active');
        cookieCard.remove();
    });

    cookieCard.querySelectorAll('.cookie-card__button--settings').forEach(settingsButtonElement => settingsButtonElement.addEventListener('click', event => {
        cookieCard.querySelectorAll('.modal__inner').forEach(element => element.style.display = 'none');
        cookieCard.querySelector('.modal__inner--manage').style.display = 'block';
        console.log('Cookie card settings clicked');
    }));

    cookieCard.querySelector('.cookie-card__button--default').addEventListener('click', event => {
        cookieCard.querySelectorAll('.modal__inner').forEach(element => element.style.display = 'none');
        cookieCard.querySelector('.modal__inner--default').style.display = 'block';
    });

    cookieCard.querySelectorAll('.cookie-card__more-info').forEach(moreInfoElement => {
        moreInfoElement.addEventListener('click', event => {
            const target = cookieCard.querySelector(moreInfoElement.dataset.target);
            if (!target) {
                console.error('Target not found for value: ' + moreInfoElement.dataset.target);
                return;
            }

            cookieCard.querySelectorAll('.modal__inner').forEach(element => element.style.display = 'none');
            target.style.display = 'block';
        });
    });

    cookieCard.querySelectorAll('.redesign-checkbox__input').forEach(checkboxElement => {
        checkboxElement.addEventListener('change', event => {
            if (checkboxElement.value == 'functional') {
                acceptFunctional = checkboxElement.checked;
                return;
            }
            if (checkboxElement.value == 'analytical') {
                acceptAnalytical = checkboxElement.checked;
                return;
            }
            if (checkboxElement.value == 'marketing') {
                acceptMarketing = checkboxElement.checked;
                return;
            }
            console.error('Checkbox not found for value: ' + checkboxElement.value);
        });
    });
};
initGoogleMaps();
initCookieCard();


// WEBPACK FOOTER //
// ./resources/assets/js/cookie-warning.js